












































































































































































































































































































































































































































































































































































import DataUtility from "@/services/DataUtility";
import { appModule } from "@/store/modules/app";
import { storeDokter } from "@/store/modules/dokter";
import { storeRujukan } from "@/store/modules/rujukan";
import { storeSpri } from "@/store/modules/spri";
import { storeUnit } from "@/store/modules/unit";
import { Component, Vue, Prop, Ref, Watch } from "vue-property-decorator";
import AsesmenMedisIgd from "@/services/AsesmenMedisIgd";
import AsesmenKeperawatanGadarStore from "@/store/modules/AsesmenKeperawatanGadarStore";
import SurveyPrimerIgdStore from "@/store/modules/SurveyPrimerIgdStore";
import AsesmenMedisIgdStore from "@/store/modules/AsesmenMedisIgdStore";
import DrawingCanvas from "@/components/drawing-canvas/DrawingCanvas.vue";
// import AsesmenAwalIgd from "@/services/AsesmenAwalIgd";
import { userModule } from "@/store/modules/user";
import CardOrderPenunjangIgdGroup from "@/components/pemeriksaan/penunjang/CardOrderPenunjangIgdGroup.vue";
import ResepIgdGroup from "@/components/resep/ResepIgdGroup.vue";
import SuketPulangCard from "@/components/pemeriksaan/resumeSuketV2/SuketPulangCard.vue";
import CardResumeRalanIgd from "@/components/pemeriksaan/resumeSuketV2/CardResumeRalanIgd.vue";
import PreviewAsesmenPerawatGadar from "./PreviewAsesmenPerawatGadar.vue";
import SuketPulang from "@/store/modules/SuketPulang";
import CardSPRI from "@/components/pemeriksaan/resumeSuketV2/CardSPRI.vue";
import SuketGawatDaruratTabPage from "../PemeriksaanPage/SuratKeteranganTabPage/SuketGawatDaruratTabPage.vue";
import SuketKematianTabPage from "../PemeriksaanPage/SuratKeteranganTabPage/SuketKematianTabPage.vue";

@Component({
  components: {
    DrawingCanvas,
    CardOrderPenunjangIgdGroup,
    ResepIgdGroup,
    SuketPulangCard,
    CardResumeRalanIgd,
    PreviewAsesmenPerawatGadar,
    CardSPRI,
    SuketGawatDaruratTabPage,
    SuketKematianTabPage
  }
})
export default class AsesmenMedisIgdPage extends Vue {
  @Prop() readonly register!: number;
  @Prop() readonly rm!: number;

  @Ref() readonly drawcanv;

  saving = false;

  rules = {
    required: value => !!value || "Kolom ini harus terisi"
  };

  get suketButtons() {
    return [
      {
        type: "suket-pulang",
        title: "Suket Pulang",
        component: "SuketPulangCard"
      },
      {
        type: "suket-gadar",
        title: "Suket Gawat Darurat",
        component: "SuketGawatDaruratTabPage"
      },
      {
        type: "suket-mati",
        title: "Suket Kematian",
        component: "SuketKematianTabPage"
      },
      {
        type: "resume-ralan",
        title: "Resume Ralan IGD",
        component: "CardResumeRalanIgd"
      },
      {
        type: "spri",
        title: "SPRI",
        component: "CardSPRI"
      }
    ];
  }

  canvasWidth = 650;
  canvasHeight = 440;
  suketActive = null;

  timePickerProps = { format: "24hr", scrollable: true };
  datePickerProps = { locale: "id" };

  id = null;

  anamnesis = null;
  keluhanUtama = null;
  riwayatPenyakitDahulu = null;
  riwayatPenyakitSekarang = null;

  anakDownScore = null;
  anakApgar1min = null;
  anakApgar5min = null;
  anakBeratBadan = null;
  anakTinggiBadan = null;

  fisikImage = null;
  fisikKepala = "";
  fisikLeher = "";
  fisikDada = "";
  fisikParu = "";
  fisikJantung = "";
  fisikPerut = "";
  fisikGenital = "";
  fisikEktrimitaAtas = "";
  fisikEktrimitaBawah = "";
  fisikTubuhBelakang = "";

  addDbn(field) {
    if (!this[field]) {
      this[field] = "";
      this[field] = this[field].concat(" Dalam batas normal").trim();
    } else {
      alert(
        "Mohon hapus isian sebelumnya terlebih dahulu untuk menetapkan ini sebagai DBN"
      );
    }
  }

  diagnosisKerja = null;
  diagnosisTambahan = null;
  terapiTL = null;

  terapiPlan = null;
  terapi = null;
  terapiTime = null;

  konsulan = [];
  caraPulang = null;
  kondisiPulang = null;
  unitKontrol = null;
  tujuanRujukan = null;
  alasanRujukan = null;
  unitRanap = null;
  catatan = null;
  observasiJam = null;
  alasanPenundaanLayanan = null;

  travelToEndemik = null;

  dokter = null;
  dokterPenerima = null;

  searchStringFaskes = "";
  faskesList = [];

  imageUrl = null;

  caraPulangOptions = [
    { id: 1, name: "Pulang" },
    { id: 2, name: "Dirujuk" },
    { id: 3, name: "Pulang Paksa" },
    { id: 4, name: "Meninggal" },
    { id: 5, name: "Rawat Inap" }
  ];
  kondisiPulangOptions = [
    { id: 1, name: "Membaik" },
    { id: 2, name: "Masih Sakit" }
    // { id: 3, name: "Meninggal" },
  ];
  alasanRujukanOptions = [
    { id: 1, name: "Sub-spesialistik" },
    { id: 2, name: "Fasilitas" },
    { id: 3, name: "Tempat Penuh" },
    { id: 4, name: "Permintaan Sendiri/ Keluarga" },
    { id: 5, name: "Lainnya" }
  ];
  terapiTLOptions = [
    { id: 1, name: "Preventif" },
    { id: 2, name: "Kuratif" },
    { id: 3, name: "Paliatif" },
    { id: 4, name: "Rehabilitatif" }
  ];

  get userState() {
    return userModule.user;
  }

  get listDokter() {
    return storeDokter.list;
  }

  get unitRalan() {
    return storeUnit.unitPagi;
  }

  get listUnitRanap() {
    return storeUnit.unitRanap;
  }

  get showUnitKontrol() {
    if (this.caraPulang && this.kondisiPulang) {
      if (this.caraPulang.id === 1 && [1, 2].includes(this.kondisiPulang.id)) {
        return true;
      }

      this.unitKontrol = null;
      return false;
    } else {
      this.unitKontrol = null;
      return false;
    }
  }

  get suratRujukan() {
    return storeRujukan.rujukan;
  }

  get isSuratRujukanExist() {
    return this.suratRujukan.length;
  }

  get spri() {
    return storeSpri.spri;
  }

  get isSpriExist() {
    return this.spri.length;
  }

  get caraPulangId() {
    return this.caraPulang ? this.caraPulang.id : null;
  }

  get tandaVital() {
    return SurveyPrimerIgdStore.asesmen?.id
      ? SurveyPrimerIgdStore.asesmen.content.tanda_vital
      : {
          tensi: "-",
          nadi: "-",
          nafas: "-",
          suhu: "-",
          saturasi: "-"
        };
  }

  get riwayatKesehatan() {
    return AsesmenKeperawatanGadarStore.asesmen?.id
      ? AsesmenKeperawatanGadarStore.asesmen.content.riwayatKesehatan
      : {
          alergi: "-",
          obat: "-",
          penyakitLalu: "-",
          makanTerakhir: "-",
          lain: "-"
        };
  }

  get riwayatObstetri() {
    return AsesmenKeperawatanGadarStore.asesmen?.id
      ? AsesmenKeperawatanGadarStore.asesmen.content.riwayatObstetri
      : {
          riwayat: "-",
          g: "-",
          p: "-",
          a: "-",
          hpht: "-",
          hpl: "-",
          palpasi: "-",
          tfu: "-",
          tbj: "-",
          his: "-",
          djj: "-",
          panggul: "-",
          vt: "-",
          lla: "-",
          tb: "-",
          bb: "-",
          kb: "-",
          kbDescription: "-"
        };
  }

  get showButtonToSpri() {
    return this.id && !this.isSpriExist;
  }

  get showButtonToRujukan() {
    return this.id && !this.isSuratRujukanExist;
  }

  get storeAsesmenMedis() {
    return AsesmenMedisIgdStore;
  }

  get storeAsesmenPerawat() {
    return AsesmenKeperawatanGadarStore;
  }

  get input() {
    return {
      pasien_rm: this.rm,
      register_id: this.register,
      content: {
        anamnesis: {
          keluhanUtama: this.keluhanUtama,
          riwayatPenyakitSekarang: this.riwayatPenyakitSekarang,
          riwayatPenyakitDahulu: this.riwayatPenyakitDahulu
        },
        asesmenAnak: {
          downScore: this.anakDownScore,
          apgar1min: this.anakApgar1min,
          apgar5min: this.anakApgar5min,
          bb: this.anakBeratBadan,
          tb: this.anakTinggiBadan
        },
        fisik: {
          kepala: this.fisikKepala,
          leher: this.fisikLeher,
          dada: this.fisikDada,
          paru: this.fisikParu,
          jantung: this.fisikJantung,
          perut: this.fisikPerut,
          genital: this.fisikGenital,
          ektrimitaAtas: this.fisikEktrimitaAtas,
          ektrimitaBawah: this.fisikEktrimitaBawah,
          tubuhBelakang: this.fisikTubuhBelakang
        },
        diagnosis: {
          kerja: this.diagnosisKerja,
          tambahan: this.diagnosisTambahan
        },
        terapi: {
          tl: this.terapiTL,
          plan: this.terapiPlan,
          terapi: this.terapi,
          time: this.terapiTime
        },
        tindakLanjut: {
          konsulan: this.konsulan.map(item => {
            return { id: item.id, nama: item.nama };
          }),
          caraPulang: this.caraPulang,
          kondisiPulang: this.kondisiPulang,
          unitKontrol: this.unitKontrol
            ? {
                id: this.unitKontrol.id,
                nama: this.unitKontrol.nama
              }
            : null,
          tujuanRujukan: this.tujuanRujukan
            ? {
                id: this.tujuanRujukan.id,
                nama: this.tujuanRujukan.nama
              }
            : null,
          alasanRujukan: this.alasanRujukan,
          unitRanap: this.unitRanap
            ? {
                id: this.unitRanap.id,
                nama: this.unitRanap.name
              }
            : null,
          observasiJam: this.observasiJam,
          alasanPenundaanLayanan: this.alasanPenundaanLayanan,
          catatan: this.catatan
        },
        lainnya: {
          travelToEndemik: this.travelToEndemik
        },
        dokterPenerima: this.dokterPenerima
          ? {
              id: this.dokterPenerima.id,
              c_doc_id: this.dokterPenerima.c_doc_id,
              nama: this.dokterPenerima.nama
            }
          : null,
        dokter: this.dokter
          ? {
              id: this.dokter.id,
              c_doc_id: this.dokter.c_doc_id,
              nama: this.dokter.nama
            }
          : null
      },
      pfisik_image: this.fisikImage
    };
  }

  get tensiText() {
    if (this.tandaVital?.tensi.length > 1) {
      const { sistole, diastole } = this.tandaVital.tensi;

      return sistole + (sistole && diastole ? "/" : "") + diastole;
    } else {
      return "-";
    }
  }

  get riwayatKb() {
    return AsesmenKeperawatanGadarStore.asesmen?.content?.riwayatObstetri.kb
      ?.name;
  }

  get canSave() {
    return (
      userModule.canAccessForm("asesmen_awal_gadar", "create") ||
      userModule.canAccessForm("asesmen_awal_gadar", "edit")
    );
  }

  mounted() {
    this.getByRegister();
    this.getFaskesList();

    SurveyPrimerIgdStore.getByRegister(this.register);
    AsesmenKeperawatanGadarStore.getByRegister(this.register);
    SuketPulang.getSuketByRegister(this.register);
  }

  refreshIsianKeperawatan() {
    SurveyPrimerIgdStore.getByRegister(this.register);
    AsesmenKeperawatanGadarStore.getByRegister(this.register);
  }

  getFaskesList() {
    const faskes = DataUtility.getListFaskes();
    faskes.then(faskes => {
      this.faskesList = faskes;
    });
  }

  buatRujukan() {
    // this.$router.push({
    //   name: "pemeriksaan-igd.konsul-rujukan",
    //   params: {
    //     param1: "param1",
    //     param2: "param2",
    //     showingModal: "rujukan"
    //   }
    // });
  }

  buatSpri() {
    // this.$router.push({
    //   name: "pemeriksaan-igd.resume-suket",
    //   params: {
    //     param1: "param1",
    //     param2: "param2",
    //     showingTab: "tab-spri"
    //   }
    // });
  }

  keHalKonsul() {
    // this.$router.push({
    //   name: "pemeriksaan-igd.konsul-rujukan"
    // });
  }

  save() {
    if (!this.saving) {
      this.saving = true;

      const sendRequest = this.id
        ? AsesmenMedisIgd.update(this.id, this.input)
        : AsesmenMedisIgd.create(this.input);

      sendRequest
        .then(() => {
          // set store module

          appModule.NoticeDelay("Berhasil Simpan Asesmen Medis");

          this.getByRegister();
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  remove() {
    const q = confirm("Hapus Asesmen Medis?");

    if (q) {
      this.deleteData();
    }
  }

  async deleteData() {
    const del = await AsesmenMedisIgd.destroy(this.id);

    if (del.data) {
      appModule.NoticeDelay("Berhasil Hapus Asesmen Medis");

      await this.getByRegister();
      this.clearInput();
    }
  }

  print() {
    // AsesmenAwalIgd.printByRegister(this.register);
  }

  getByRegister() {
    AsesmenMedisIgdStore.getByRegister(this.register).then(() => {
      const data = this.storeAsesmenMedis.asesmen;

      if (data) {
        const content = data.content;

        this.id = data.id;

        this.keluhanUtama = content.anamnesis.keluhanUtama;
        this.riwayatPenyakitDahulu = content.anamnesis.riwayatPenyakitDahulu;
        this.riwayatPenyakitSekarang =
          content.anamnesis.riwayatPenyakitSekarang;

        this.anakDownScore = content.asesmenAnak.downScore;
        this.anakApgar1min = content.asesmenAnak.apgar1min;
        this.anakApgar5min = content.asesmenAnak.apgar5min;
        this.anakBeratBadan = content.asesmenAnak.bb;
        this.anakTinggiBadan = content.asesmenAnak.tb;

        // this.fisikImage = data.image.url;
        this.fisikKepala = content.fisik.kepala;
        this.fisikLeher = content.fisik.leher;
        this.fisikDada = content.fisik.dada;
        this.fisikParu = content.fisik.paru;
        this.fisikJantung = content.fisik.jantung;
        this.fisikPerut = content.fisik.perut;
        this.fisikGenital = content.fisik.genital;
        this.fisikEktrimitaAtas = content.fisik.ektrimitaAtas;
        this.fisikEktrimitaBawah = content.fisik.ektrimitaBawah;
        this.fisikTubuhBelakang = content.fisik.tubuhBelakang;

        this.diagnosisKerja = content.diagnosis.kerja;
        this.diagnosisTambahan = content.diagnosis.tambahan;

        this.terapiTL = content.terapi.tl;
        this.terapiPlan = content.terapi.plan;
        this.terapi = content.terapi.terapi;
        this.terapiTime = content.terapi.time;
        // ? new Date(content.terapi.time)
        // : null;

        this.konsulan = content.tindakLanjut.konsulan;
        this.caraPulang = content.tindakLanjut.caraPulang;
        this.kondisiPulang = content.tindakLanjut.kondisiPulang;
        this.unitKontrol = content.tindakLanjut.unitKontrol;
        this.tujuanRujukan = content.tindakLanjut.tujuanRujukan;
        this.alasanRujukan = content.tindakLanjut.alasanRujukan;
        this.unitRanap = content.tindakLanjut.unitRanap;
        this.observasiJam = content.tindakLanjut.observasiJam;
        this.alasanPenundaanLayanan =
          content.tindakLanjut.alasanPenundaanLayanan;
        this.catatan = content.tindakLanjut.catatan;

        this.dokter = content.dokter;
        this.dokterPenerima = content.dokterPenerima;

        this.imageUrl = data.pemeriksaan_image_url;
      }
    });
  }

  updateDrawedImage(image) {
    this.fisikImage = image;
  }

  @Watch("caraPulang")
  changeCaraPulang(val) {
    if (val) {
      if (val.id === 1) {
        this.tujuanRujukan = null;
        this.alasanRujukan = null;
        this.unitRanap = null;
      } else if (val.id === 2) {
        this.unitKontrol = null;
        this.kondisiPulang = null;
        this.unitRanap = null;
      } else if (val.id === 5) {
        this.unitKontrol = null;
        this.kondisiPulang = null;
        this.tujuanRujukan = null;
        this.alasanRujukan = null;
      } else {
        this.unitKontrol = null;
        this.kondisiPulang = null;
        this.tujuanRujukan = null;
        this.alasanRujukan = null;
        this.unitRanap = null;
      }
    }
  }

  dummyData() {
    // this.anamnesis =
    //   "Anamnesis dokter tentang keadaan fisik pasien yang bisa dijelaskan dengan kalimat yang panjang";
    this.keluhanUtama = "keluhan utama";
    this.riwayatPenyakitDahulu = "riwayat penyakit dahulu";
    this.riwayatPenyakitSekarang = "riwayat penyakit sekarang";

    this.anakDownScore = 5;
    this.anakApgar1min = 5;
    this.anakApgar5min = 5;
    this.anakBeratBadan = 34;
    this.anakTinggiBadan = 140;

    this.fisikKepala = "fisik kepala";
    this.fisikLeher = "fisik leher";
    this.fisikParu = "fisik paru";
    this.fisikJantung = "fisik jantung";
    this.fisikPerut = "fisik perut";
    this.fisikGenital = "fisik genital";
    this.fisikEktrimitaAtas = "fisik ektrimita";
    this.fisikEktrimitaBawah = "fisik ektrimita bawah";
    this.fisikTubuhBelakang = "tubuh bagian belakang";

    this.diagnosisKerja = "diagnosis text";
    this.diagnosisTambahan = "diagnosis  tambahan text";

    this.terapiTL = this.terapiTLOptions.find(({ id }) => id === 1);
    this.terapiPlan = "rencana terapi perut";
    this.terapi = "terapi perut";
    this.terapiTime = new Date();

    this.konsulan = [
      { id: 268, nama: "dr. Bagus" },
      { id: 428, nama: "dr. Tritia" }
    ];
    this.caraPulang = this.caraPulangOptions.find(({ id }) => id === 1);
    this.kondisiPulang = this.kondisiPulangOptions.find(({ id }) => id === 2);
    this.unitKontrol = this.unitRalan.find(({ id }) => id == "10");
    this.catatan = "catatan lain";

    this.dokter = this.listDokter.find(({ id }) => id == 268);
  }

  clearInput() {
    this.id = null;

    this.anamnesis = null;
    this.keluhanUtama = null;
    this.riwayatPenyakitDahulu = null;
    this.riwayatPenyakitSekarang = null;

    this.anakDownScore = null;
    this.anakApgar1min = null;
    this.anakApgar5min = null;
    this.anakBeratBadan = null;
    this.anakTinggiBadan = null;

    this.fisikImage = null;
    this.fisikKepala = "";
    this.fisikLeher = "";
    this.fisikDada = "";
    this.fisikParu = "";
    this.fisikJantung = "";
    this.fisikPerut = "";
    this.fisikGenital = "";
    this.fisikEktrimitaAtas = "";
    this.fisikEktrimitaBawah = "";
    this.fisikTubuhBelakang = "";

    this.diagnosisKerja = null;
    this.diagnosisTambahan = null;
    this.terapiTL = null;

    this.terapiPlan = null;
    this.terapi = null;
    this.terapiTime = null;

    this.konsulan = [];
    this.caraPulang = null;
    this.kondisiPulang = null;
    this.unitKontrol = null;
    this.tujuanRujukan = null;
    this.alasanRujukan = null;
    this.unitRanap = null;
    this.catatan = null;
    this.observasiJam = null;
    this.alasanPenundaanLayanan = null;

    this.dokter = null;
    this.dokterPenerima = null;

    this.searchStringFaskes = "";

    this.imageUrl = null;
  }

  openSuketPulangInput() {
    alert("should open suket punag input");
  }
}
